'use strict';
module.exports = function raceAgainstTimeout(navigatorShim, promise, delay) {
	let timeoutId;
	const timeout = new Promise((resolve, reject) => {
		timeoutId = navigatorShim.setTimeout(() => reject('timeout'), delay);
	});
	return Promise.race([promise, timeout])
	.then(result => {
		navigatorShim.clearTimeout(timeoutId);
		return result;
	})
	.catch(e => {
		navigatorShim.clearTimeout(timeoutId);
		throw e;
	});
};

